import { Progress } from '@chakra-ui/react';

export default function AppLoader() {
	return <Progress data-testid="loader" isIndeterminate colorScheme="primary" h={1} />;
}
